 $(document).ready(function() {

    var imgs = $('.modal-slider .single-img img');//jQuery class selector
    imgs.each(function(){
      var img = $(this);
      var width = img.width(); //jQuery width method
      var height = img.height(); //jQuery height method
      if(width < height){
         img.addClass('portrait');
      }else{
         img.addClass('landscape');
      }
  });


  $('.modal-slider-section .project-gallery li').on('click', function() {
    var clicked = $(this);
    var clickedClass= clicked.attr('class'); 
    console.log(clickedClass);
    $('.modal-slider-overlay').addClass('show');
    $('.modal-slider .slick-slide').removeClass('slick-active slick-current forward');

   $('.modal-slider .slick-slide').each(function() {
                var crrnt = $(this); 

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('slick-active slick-current forward');
                }

                else {
                    crrnt.removeClass('slick-active slick-current forward');
                }
            });	
	
  });

 


  
  $('.modal-slider-section .modal-slider-overlay .slider-close').on('click', function() {
    $('.modal-slider-overlay').removeClass('show');
  });



   var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
});